import styled from "styled-components"

export const Small = styled.div`
  letter-spacing: 0.4px;
  margin-top: 0;
  font-size: 0.75rem;
  margin-bottom: 0;
`
